import { useTenantNavigation } from '@/hooks/useTenantNavigation'
import { Button, Card, CardContent } from '@repo/ui/components'
import { createFileRoute } from '@tanstack/react-router'
import { CheckCircle2Icon } from 'lucide-react'
import { useTranslation } from 'react-i18next'

export const Route = createFileRoute('/_auth/carriers/$slug/driver-onboarding/signed')({
  component: SignedPage,
  staticData: {
    title: 'route.dashboard',
  },
})

function SignedPage() {
  const { t } = useTranslation('ui')
  const { slug, navigate } = useTenantNavigation()

  const goToDashboard = () => {
    navigate({ to: '/carriers/$slug/driver-onboarding/dashboard', params: { slug } })
  }

  return (
    <div className="flex min-h-[60vh] items-center justify-center p-6">
      <Card className="max-w-md text-center">
        <CardContent className="space-y-4 py-8">
          <div className="mx-auto flex size-14 items-center justify-center rounded-full bg-emerald-100">
            <CheckCircle2Icon className="size-7 text-emerald-600" />
          </div>
          <h1 className="text-xl font-semibold">{t('dashboard.card.signed.heading')}</h1>
          <p className="text-sm text-muted-foreground">{t('dashboard.card.signed.description')}</p>
          <Button onPress={goToDashboard}>{t('dashboard.signed.backToDashboard')}</Button>
        </CardContent>
      </Card>
    </div>
  )
}
